<template>
  <div class="customer-edit-quotation">
    <div class="customer-edit-quotation__top row">
      <div class="col-7 d-flex align-items-center">
        <svg @click="expanded = !expanded" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"
          fill="none" class="customer-edit-quotation__chevron" :class="{ expanded: expanded }">
          <path
            d="M13.3416 11.2579L1.65836 11.2579C0.850115 11.2579 0.445991 10.2817 1.01812 9.70953L6.85749 3.86563C7.21167 3.51145 7.78834 3.51145 8.14251 3.86563L13.9819 9.70953C14.554 10.2817 14.1499 11.2579 13.3416 11.2579Z"
            fill="#A6AAB4" />
        </svg>
        <h3 class="customer-edit-quotation__title">{{ quotation_name }}</h3>
        <h4 v-if="!unquoted" class="customer-edit-quotation__date">
          {{ quotation_date }}
        </h4>
        <h5 class="customer-edit-quotation__status" :class="quotation_status_class">
          {{ quotation_status }}
        </h5>
        <h5 class="customer-edit-quotation__amounts">
          {{ quotation_amounts }}
        </h5>
        <h5 v-if="quotation_has_progress" class="customer-edit-quotation__progress">
          <div>Inicio: <strong>{{ start_date }}</strong></div>
          <div>Fin (Est.): <strong>{{ estimated_finish_date }}</strong></div>
          <div class="progress" style="min-width:100px">
            <div class="progress-bar" role="progressbar"
              :style="{ width: progress + '%', 'background-color': progress_bg }" :aria-valuenow="progress"
              aria-valuemin="0" aria-valuemax="100">{{ progress }}%</div>
          </div>
        </h5>
      </div>
      <div v-if="!unquoted" class="col-5 d-flex align-items-center justify-content-end">
        <div class="form-check form-check-switcher form-check-inline">
          <input type="checkbox" v-bind:true-value="true" v-bind:false-value="false" :checked="quotation.is_approved"
            @input="changeApproved" class="form-check-input" :id="'quotation_is_approved_' + quotation.id" />
          <label class="form-check-label" :for="'quotation_is_approved_' + quotation.id">
            <span v-if="quotation.is_approved"> Plan aprobado </span>
            <span v-else> Aprobar plan </span>
          </label>
        </div>

        <button class="btn btn-wabident-round mx-2" @click="editQuotation">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g clip-path="url(#clip0_210_2272)">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.3966 0.931258L11.0582 1.59338C11.2775 1.81306 11.4006 2.11089 11.4006 2.42142C11.4006 2.73196 11.2775 3.02979 11.0582 3.24946L10.2479 4.06058L7.93219 1.74216L8.74245 0.931258C9.18347 0.489549 9.95444 0.489549 10.3966 0.931258ZM1.32738 8.35394L7.2701 2.4045L9.58585 4.72292L3.6427 10.6721C3.61285 10.7022 3.57534 10.7235 3.53425 10.7337L0.890532 11.3929C0.87202 11.3976 0.852993 11.4 0.833895 11.4C0.798372 11.4 0.76332 11.3918 0.731396 11.3762C0.699471 11.3607 0.671512 11.338 0.649637 11.31C0.627763 11.282 0.612547 11.2493 0.605144 11.2145C0.597741 11.1798 0.598344 11.1438 0.606908 11.1092L1.2657 8.4625C1.2762 8.42145 1.2975 8.38396 1.32738 8.35394Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_210_2272">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Editar Plan
        </button>

        <div @click="print" role="button" class="btn-print" data-toggle="tooltip" title="Generar PDF">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23">
            <path
              d="M5.053 3.79h13.894V1.262H5.053V3.79zm-1.264 0V.631c0-.35.283-.632.632-.632H19.58c.349 0 .631.283.631.632v3.157h3.158c.35 0 .632.283.632.632v8.842a.632.632 0 0 1-.632.632h-3.157v3.158a.631.631 0 0 1-.185.446l-5.053 5.053a.632.632 0 0 1-.447.185H4.421a.632.632 0 0 1-.632-.632v-8.21H.632A.632.632 0 0 1 0 13.263V4.421c0-.349.283-.632.632-.632h3.157zm0 8.842V12c0-.349.283-.632.632-.632H19.58c.349 0 .631.283.631.632v.632h2.527v-7.58H1.263v7.58H3.79zm11.369 7.949l2.896-2.897h-2.896v2.896zm-1.263.893v-4.421c0-.35.283-.632.631-.632h4.421v-3.79H5.053v8.843h8.842zm-6.948-6.316a.632.632 0 0 1 0-1.263h8.843a.632.632 0 0 1 0 1.263H6.947zm0 2.526a.632.632 0 0 1 0-1.263h3.79a.631.631 0 1 1 0 1.263h-3.79zm0 2.526a.632.632 0 1 1 0-1.263h3.79a.631.631 0 1 1 0 1.264h-3.79zM4.421 7.58a.632.632 0 0 1 0-1.263h2.526a.632.632 0 0 1 0 1.263H4.421z" />
          </svg>
        </div>

        <div @click="sendMail" class="btn-sendmail" data-toggle="tooltip" title="Enviar por correo">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17">
            <path
              d="M2.341 0A2.35 2.35 0 0 0 0 2.341V14.05a2.35 2.35 0 0 0 2.341 2.341h19.317A2.35 2.35 0 0 0 24 14.05V2.34A2.35 2.35 0 0 0 21.659 0H2.34zm0 1.17h19.317c.17 0 .323.04.467.101L12.732 9.66c-.444.396-1 .396-1.445 0L1.875 1.27c.144-.061.297-.1.466-.1zM1.18 2.224l6.732 6-6.613 6.356a1.21 1.21 0 0 1-.128-.53V2.34c0-.04.005-.079.009-.118zm21.64 0c.004.04.01.077.01.118V14.05c0 .19-.051.373-.129.53l-6.594-6.366 6.713-5.99zM15.23 9l6.457 6.22H2.314L8.79 9.01l1.719 1.527a2.25 2.25 0 0 0 3 0L15.229 9z" />
          </svg>
        </div>

        <div v-if="clinic_config.quotation_enable_duplication" @click="duplicateQuotation" class="btn-consent mr-3"
          data-toggle="tooltip" title="Duplicar">
          <svg width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 52 52" xml:space="preserve">
            <g>
              <path d="M45,0H11c-0.552,0-1,0.448-1,1v3H7C6.448,4,6,4.448,6,5v46c0,0.552,0.448,1,1,1h34c0.552,0,1-0.448,1-1v-3h3
                c0.552,0,1-0.448,1-1V1C46,0.448,45.552,0,45,0z M40,50H8V6h23v8c0,0.552,0.448,1,1,1h8V50z M33,7.414L38.586,13H33V7.414z M44,46
                h-2V14c0-0.022-0.011-0.041-0.013-0.063c-0.006-0.088-0.023-0.173-0.051-0.257c-0.011-0.032-0.019-0.063-0.034-0.094
                c-0.049-0.106-0.11-0.207-0.196-0.293l-9-9c-0.086-0.086-0.187-0.147-0.293-0.196c-0.031-0.014-0.062-0.022-0.094-0.033
                c-0.084-0.029-0.169-0.046-0.258-0.051C32.041,4.011,32.021,4,32,4H12V2h32V46z" />
            </g>
          </svg>
        </div>

        <div v-if="clinic_config.quotation_generate_consent" @click="generateConsent" class="btn-consent mr-3"
          date-toggle="tooltip" title="Generar Consentimiento">
          <svg width="24px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 412.65 412.65" xml:space="preserve">
            <g>
              <path d="M342.963,166.078c12.312-15.706,48.483-61.846,48.483-61.846c13.025-16.616,12.695-38.62-3.919-51.645
                                        c-16.615-13.026-38.063-8.091-51.087,8.524l-49.043,62.559c0,0-1.042,1.33,0.054,2.189c11.518,9.03,42.729,33.496,51.556,40.416
                                        C340.508,167.452,341.361,168.121,342.963,166.078z" />
              <path
                d="M282.399,140.946c-0.727-0.569-1.289-0.425-1.784,0.274c-5.34,7.567-37.382,52.895-49.465,68.308
                                        c-7.602,9.698-7.964,27.592-5.17,37.73c0.093,0.337,0.456,0.774-0.082,1.46c-1.485,1.895-2.339,3.222-3.198,4.316
                                        c-2.32,2.96-1.054,6.478,1.114,8.103c2.262,1.695,6.091,2.323,8.412-0.636c0.86-1.098,1.95-2.25,3.44-4.15
                                        c0.421-0.537,0.936-0.444,1.226-0.435c10.489,0.333,27.928-4.266,35.565-14.008c12.19-15.55,48.843-57.772,54.427-64.198
                                        c0.463-0.532,0.919-1.171-0.084-1.958C315.7,167.052,293.761,149.853,282.399,140.946z" />
              <path
                d="M377.264,168.661c-2.374,3.03-6.757,3.561-9.786,1.186l0,0c-3.031-2.375-3.561-6.757-1.186-9.788l33.901-43.245
                                        c2.374-3.03,6.756-3.561,9.786-1.185l0,0c3.03,2.376,3.561,6.757,1.186,9.787L377.264,168.661z" />
            </g>
            <g>
              <path
                d="M232.299,165.483c0,2.929-2.396,5.327-5.325,5.327H47.264c-2.931,0-5.327-2.397-5.327-5.327v-5.549
                                        c0-2.929,2.396-5.325,5.327-5.325h179.711c2.929,0,5.325,2.396,5.325,5.325v5.549H232.299z" />
            </g>
            <path d="M232.299,279.388c0,2.928-2.398,5.324-5.329,5.324h-69.828c-2.931,0-5.327-2.396-5.327-5.324v-4.551
                                c0-2.929,2.396-5.325,5.327-5.325h69.828c2.931,0,5.329,2.396,5.329,5.325V279.388z" />
            <g>
              <path
                d="M232.299,116.312c0,2.929-2.396,5.325-5.325,5.325H47.264c-2.931,0-5.327-2.396-5.327-5.325v-5.551
                                        c0-2.929,2.396-5.325,5.327-5.325h179.711c2.929,0,5.325,2.396,5.325,5.325v5.551H232.299z" />
            </g>
            <path
              d="M254.649,279.051v55.688c0,10.175-8.325,18.5-18.5,18.5H38.088c-10.175,0-18.5-8.325-18.5-18.5V77.913
                                c0-10.175,8.325-18.5,18.5-18.5h198.06c10.175,0,18.5,8.325,18.5,18.5v59.163c0,5.662,2.795,2.839,4.089,1.151
                                c3.303-4.308,9.538-11.459,12.05-14.139c2.589-2.762,3.449-5.119,3.449-8.429V58.324c0-10.175-8.325-18.5-18.5-18.5H18.5
                                c-10.175,0-18.5,8.325-18.5,18.5v296.002c0,10.175,8.325,18.5,18.5,18.5h237.237c10.175,0,18.5-8.325,18.5-18.5v-83
                                c0-4.833-2.813-4.079-4.226-3.389c-3.892,1.901-7.772,3.316-11.309,4.366C257.289,272.723,254.649,273.326,254.649,279.051z" />
          </svg>
        </div>




        <div class="customer-edit-quotation__handle">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.20023 3.30013C8.20023 4.29431 7.39428 5.10025 6.4001 5.10025C5.40592 5.10025 4.59998 4.29431 4.59998 3.30013C4.59998 2.30594 5.40592 1.5 6.4001 1.5C7.39428 1.5 8.20023 2.30594 8.20023 3.30013ZM8.20023 10.4998C8.20023 11.494 7.39428 12.2999 6.4001 12.2999C5.40592 12.2999 4.59998 11.494 4.59998 10.4998C4.59998 9.50561 5.40592 8.69966 6.4001 8.69966C7.39428 8.69966 8.20023 9.50561 8.20023 10.4998ZM6.4001 19.5C7.39428 19.5 8.20023 18.6941 8.20023 17.6999C8.20023 16.7057 7.39428 15.8997 6.4001 15.8997C5.40592 15.8997 4.59998 16.7057 4.59998 17.6999C4.59998 18.6941 5.40592 19.5 6.4001 19.5ZM15.3999 3.30013C15.3999 4.29431 14.5939 5.10025 13.5998 5.10025C12.6056 5.10025 11.7996 4.29431 11.7996 3.30013C11.7996 2.30594 12.6056 1.5 13.5998 1.5C14.5939 1.5 15.3999 2.30594 15.3999 3.30013ZM13.5998 12.2999C14.5939 12.2999 15.3999 11.494 15.3999 10.4998C15.3999 9.50561 14.5939 8.69966 13.5998 8.69966C12.6056 8.69966 11.7996 9.50561 11.7996 10.4998C11.7996 11.494 12.6056 12.2999 13.5998 12.2999ZM15.3999 17.6999C15.3999 18.6941 14.5939 19.5 13.5998 19.5C12.6056 19.5 11.7996 18.6941 11.7996 17.6999C11.7996 16.7057 12.6056 15.8997 13.5998 15.8997C14.5939 15.8997 15.3999 16.7057 15.3999 17.6999Z"
              fill="#A6AAB4" />
          </svg>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="expanded" class="customer-edit-quotation__content container-fluid">
        <draggable v-if="quotation.treatments.length" v-model="quotation.treatments"
          handle=".customer-edit-quotation-treatment__handle" @change="onOrderChanged">
          <transition-group>
            <customer-edit-quotation-treatment v-if="canShowTreatment(treatment)" :doctor_names="doctor_names"
              v-for="treatment in quotation.treatments" :treatment="treatment"
              :selected="selected_treatments[treatment.id]" @select="treatmentSelected" @approve="approveTreatment"
              @edit="editTreatment(treatment)" :key="treatment.id"></customer-edit-quotation-treatment>
          </transition-group>
        </draggable>

        <div v-else class="customer-edit-quotation__empty">
          <div v-if="quotation.quotationlines.length">
            No hay tratamientos asignados a este plan pero si hay líneas de
            presupuesto. <br />
            Revisa el plan "Tratamientos Importados" para ver las discrepancias
            entre lo presupuestado y lo tratado.
          </div>
          <div v-else>
            No hay tratamientos asignados a este plan. Por favor, edita el plan
            para asignar tratamientos
          </div>
        </div>

        <div class="customer-edit-quotation__treatments-bottom row">
          <div class="col-md-1 text-left">
            <button style="
                width: 32px;
                height: 32px;
                border-radius: 16px;
                padding: 7px;
              " class="btn btn-wabident-round d-flex align-items-center justify-content-center" @click="addTreatment">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_212_1271)">
                  <path
                    d="M15.6762 7.57617L10.4238 7.57617L10.4238 2.32382C10.4238 1.9462 10.2738 1.58404 10.0068 1.31702C9.73977 1.05 9.37762 0.899995 9 0.899995C8.62237 0.899995 8.26022 1.05 7.9932 1.31702C7.72618 1.58404 7.57617 1.9462 7.57617 2.32382L7.57617 7.57617L2.32382 7.57617C1.9462 7.57617 1.58404 7.72618 1.31702 7.9932C1.05 8.26022 0.899993 8.62237 0.899993 8.99999C0.899993 9.37762 1.05 9.73977 1.31702 10.0068C1.58404 10.2738 1.9462 10.4238 2.32382 10.4238L7.57617 10.4238L7.57617 15.6762C7.57617 16.0538 7.72618 16.4159 7.9932 16.683C8.26022 16.95 8.62237 17.1 8.99999 17.1C9.37762 17.1 9.73977 16.95 10.0068 16.683C10.2738 16.4159 10.4238 16.0538 10.4238 15.6762L10.4238 10.4238L15.6762 10.4238C16.0538 10.4238 16.4159 10.2738 16.683 10.0068C16.95 9.73977 17.1 9.37762 17.1 9C17.1 8.62237 16.95 8.26022 16.683 7.9932C16.4159 7.72618 16.0538 7.57617 15.6762 7.57617Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_212_1271">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
          <div class="col text-center">
            <button v-if="selected_treatment_ids.length" class="btn btn-wabident-round" @click="approveTreatments">
              Aprobar tratamientos
            </button>
            <div v-else class="customer-edit-quotation__treatments-label">
              Recuerda que puedes seleccionar varios tratamientos para
              aprobarlos/borrarlos simultáneamente
            </div>
          </div>
          <div class="col-md-1 text-right">
            <transition name="fade">
              <button v-if="selected_treatment_ids.length" style="
                  width: 32px;
                  height: 32px;
                  border-radius: 16px;
                  padding: 7px;
                " class="btn btn-wabident-delete" @click="deleteTreatments"></button>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      required: true,
    },
    quotation: {
      required: true,
    },
    unquoted: {
      default: false,
    },
    doctor_names: {
      required: true,
    },
    product: {
      default: null,
    },
    tooth: {
      default: null,
    }
  },
  data() {
    return {
      expanded: false,
      selected_treatments: {},
    };
  },
  computed: {
    quotation_has_progress() {
      return this.quotation.estimated_progress !== null;
    },
    start_date() {
      if (!this.quotation_has_progress) {
        return '';
      }
      return moment.utc(this.quotation.start_date).format('DD/MM/YYYY');
    },
    estimated_finish_date() {
      if (!this.quotation_has_progress) {
        return '';
      }
      return moment.utc(this.quotation.estimated_finish_date).format('DD/MM/YYYY');
    },
    estimated_progress() {
      if (this.quotation.estimated_progress === null) {
        return 0;
      }

      let estimated_progress = Math.round(Number(this.quotation.estimated_progress) * 100);
      return estimated_progress;
    },
    actual_progress() {
      if (this.quotation.actual_progress === null) {
        return 0;
      }

      let actual_progress = Math.round(Number(this.quotation.actual_progress) * 100);
      return actual_progress;
    },
    progress_bg() {
      if (this.actual_progress >= 100) {
        return 'var(--theme-color-attended)';
      }

      if (this.progress >= 100) {
        return 'var(--theme-color-absent)';
      } else if (this.progress) {
        return 'var(--theme-color-urgent)';
      }

      return 'var(--theme-color-attended)';
    },
    progress() {
      return (this.actual_progress >= 100) ? 100 : this.estimated_progress;
    },
    is_partial_or_approved() {
      return this.is_partial || this.quotation.is_approved;
    },
    quotation_status_class() {
      if (this.quotation.is_approved) {
        return { approved: true };
      }

      if (this.is_partial) {
        return { partial: true };
      }

      if (this.quotation.reject_reason && this.quotation.reject_reason != "") {
        return { rejected: true };
      }

      return { pending: true };
    },
    quotation_status() {
      if (this.quotation.is_approved) {
        return "Aprobado";
      }

      if (this.is_partial) {
        return "Apr. Parcial";
      }

      if (this.quotation.reject_reason && this.quotation.reject_reason != "") {
        return "Rechazado";
      }

      return "Pendiente";
    },
    quotation_amounts() {
      let net = WabiDent.fmtMoney(this.quotation.net_price);
      let approved = WabiDent.fmtMoney(this.quotation.approved_price);

      if (this.is_partial) {
        return `${approved} (de ${net})`;
      }

      return net;
    },
    is_partial() {
      return (
        this.quotation.approved_price > 0 &&
        this.quotation.approved_price < this.quotation.net_price
      );
    },
    net_price() {
      return WabiDent.fmtMoney(this.quotation.net_price);
    },
    approved_price() {
      return WabiDent.fmtMoney(this.quotation.approved_price);
    },
    selected_treatment_ids() {
      let ret = [];
      for (const id in this.selected_treatments) {
        if (this.selected_treatments[id]) {
          ret.push(id);
        }
      }
      return ret;
    },
    quotation_date() {
      return moment(this.quotation.created_at).format("DD/MM/YY");
    },
    quotation_name() {
      if (this.quotation.notes === null || this.notes === "") {
        return "Plan #" + this.quotation.code;
      }

      return this.quotation.notes;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "clinic_config"]),
  },
  methods: {
    canShowTreatment(treatment) {
      if (this.product && (this.product != treatment.product_id)) {
        return false;
      }

      if (this.tooth && !(treatment.teeth.includes(String(this.tooth)) || treatment.teeth.includes(Number(this.tooth)))) {
        return false;
      }

      return true;
    },
    treatmentSelected(checked, id) {
      this.$set(this.selected_treatments, id, checked);
    },
    changeApproved(ev) {
      this.selected_treatments = {};
      this.$emit("approve", ev.target.checked, this.quotation);
    },
    editQuotation() {
      this.$emit("edit", this.quotation);
      this.selected_treatments = {};
    },
    editTreatment(treatment) {
      this.$emit("editTreatment", treatment);
      this.selected_treatments = {};
    },
    addTreatment() {
      this.$emit("addTreatment", this.quotation);
      this.selected_treatments = {};
    },
    deleteTreatments() {
      this.errorwindow.show(
        "Confirmación",
        "¿Deseas borrar estos tratamientos?",
        "Borrar",
        "Cancelar",
        () => {
          this.$emit("deleteTreatments", this.selected_treatment_ids);
          this.selected_treatments = {};
        }
      );
    },
    approveTreatments() {
      this.$emit("approveTreatments", this.selected_treatment_ids, true);
      this.selected_treatments = {};
    },
    approveTreatment(approved, treatment_id) {
      this.$emit("approveTreatments", [treatment_id], !approved);
      this.selected_treatments = {};
    },
    onOrderChanged() {
      const treatments = this.quotation.treatments.map((t) => t.id);
      const quotation_id = this.unquoted ? null : this.quotation.id;

      this.$emit("reorderTreatments", treatments, quotation_id);
      this.selected_treatments = {};
    },
    print() {
      window.open(`/quotation/${this.quotation.id}/pdf`, "_blank");
    },
    generateConsent() {
      this.errorwindow.show('Confirmación', 'Esto generará un Consentimiento nuevo a partir del Plan actual. ¿Estás seguro/a?', 'Generar', 'Cancelar', () => {
        axios
          .get(`/quotation/${this.quotation.id}/consent`)
          .then((response) => {
            let data = response.data;
            if (data.error) {
              this.msgwindow.error(data.message);
            } else {
              this.msgwindow.success(
                'Consentimiento Generado, consulta la sección Documentos'
              );
            }
          })
          .catch((error) => {
            console.log("[ERR] sendConsent ", error);
            this.msgwindow.error("Error generando documento!");
          });
      });
    },
    duplicateQuotation() {
      this.errorwindow.show('Confirmación', 'Esto generará un duplicado del Plan, con todos sus tratamientos. ¿Estás seguro/a?.', 'Duplicar', 'Cancelar', () => {
        axios
          .post(`/customer/${this.customer.id}/quotation/${this.quotation.id}/duplicate`)
          .then((response) => {
            let data = response.data;
            if (data.error) {
              this.msgwindow.error(data.message);
            } else {
              this.msgwindow.success(
                'Plan Duplicado'
              );
            }
          })
          .catch((error) => {
            console.log("[ERR] duplicateQuotation ", error);
            this.msgwindow.error("Error duplicando Plan");
          }).then(() => {
            this.$emit('submit');
          });
      });
    },
    sendMail() {
      axios
        .get(`/quotation/${this.quotation.id}/email`)
        .then((response) => {
          let data = response.data;
          if (data.error) {
            this.msgwindow.error(data.message);
          } else {
            this.msgwindow.success(
              "Enviado por correo a " + this.customer.email
            );
          }
        })
        .catch((error) => {
          console.log("[ERR] sendQuotationEmail ", error);
          this.msgwindow.error("Error enviando correo !");
        });
    },
  },
  mounted() {
    this.expanded = false;
    this.selected_treatments = {};
    this.is_approved = this.quotation.is_approved;
  },
};
</script>

<style lang="scss">
.customer-edit-quotation {
  display: block;
  width: 100%;
  border-bottom: 3px var(--theme-grey-bg) solid;
  padding: 20px 0;

  &__top {}

  &__chevron {
    cursor: pointer;
    transition: 0.2s ease;

    &.expanded {
      transform: rotate(180deg);
    }
  }

  &__title {
    margin: 0 0 0 18px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
  }

  &__date {
    margin: 0 0 0 18px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1;
    color: var(--theme-grey);
  }

  &__status {
    margin: 0 0 0 18px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    color: white;
    border-radius: 30px;
    padding: 6px 12px;
    background-color: var(--theme-grey);
    transition: all 0.3s;

    &.approved {
      background-color: var(--theme-color-attended);
    }

    &.partial {
      background-color: var(--theme-color-arrived);
    }

    &.rejected {
      background-color: var(--theme-color-absent);
    }
  }

  &__amounts {
    margin: 0 0 0 18px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1;
    color: var(--theme-text);
  }

  &__progress {
    margin: 0 0 0 18px;
    font-size: 14px;
    line-height: 1;
    color: var(--theme-text);
    display: flex;
    flex-flow: row wrap;
    gap: 8px;
  }

  &__handle {
    cursor: grab;
  }

  &__content {
    padding: 20px 35px 0 35px;
  }

  &__treatments-label {
    color: var(--texto-gris, #a6aab4);
    font-size: 12px;
  }

  &__empty {
    background-color: var(--theme-grey-bg);
    font-weight: 700;
    border-radius: 20px;
    margin: 10px 10px 10px 0;
    padding: 20px;
  }

  .btn-consent,
  .btn-sendmail,
  .btn-print {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    cursor: pointer;
    margin: 5px 15px 0 0;
    display: block;
    width: 24px;
    color: var(--theme-grey) !important;
    transition: all 0.2s;
    fill: currentColor;
    position: relative;

    &:hover {
      color: var(--theme-color) !important;
    }

    svg {
      width: 100%;
      object-fit: contain;
      object-position: center center;
      transition: all 0.2s;
      fill: currentColor;

      * {
        fill: currentColor;
      }
    }
  }
}
</style>
